// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.schedule.scheduleitem.DeleteScheduleItemRequest */
/* istanbul ignore next */
@GandalfModel
export class DeleteScheduleItemRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.UpdateMode)
	@GandalfValidator({ notNull: { message: 'ChangeMode is required' } })
	@GandalfProperty({ designType: constants.UpdateMode, isRequired: true })
	changeMode!: constants.UpdateMode;

	@GandalfValidator({ notNull: { message: 'Id is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

}
